import { Geolocation } from '@capacitor/geolocation';
import { isNative } from '../platform';

export interface Coords {
  latitude: number;
  longitude: number;
  accuracy: number;
}

/**
 * Get the current position. Uses the Capacitor plugin on native (with OS
 * permission prompts) and the browser Geolocation API on web. Returns null if
 * permission is denied or the position is unavailable.
 */
export async function getCurrentPosition(): Promise<Coords | null> {
  try {
    if (isNative) {
      const perm = await Geolocation.checkPermissions();
      if (perm.location !== 'granted') {
        const req = await Geolocation.requestPermissions();
        if (req.location !== 'granted') return null;
      }
      const pos = await Geolocation.getCurrentPosition({ enableHighAccuracy: true, timeout: 10000 });
      return {
        latitude: pos.coords.latitude,
        longitude: pos.coords.longitude,
        accuracy: pos.coords.accuracy,
      };
    }

    return await new Promise((resolve) => {
      if (!('geolocation' in navigator)) return resolve(null);
      navigator.geolocation.getCurrentPosition(
        (pos) =>
          resolve({
            latitude: pos.coords.latitude,
            longitude: pos.coords.longitude,
            accuracy: pos.coords.accuracy,
          }),
        () => resolve(null),
        { enableHighAccuracy: true, timeout: 10000 },
      );
    });
  } catch {
    return null;
  }
}
